__webpack_require__.p = "/kendo-angular-ui/components/";